export default "__VITE_ASSET__46319eb2__"